import { OrdersIntentionsData } from '@interfaces/analysis/orders-intentions-for-approval/orders-intentions-data';
import { ParseDateToBrWithHours } from 'helper/format-date-helper';
import { useMemo, useState } from 'react';
import { Accordion, Button, Card, Col, Row, Table } from 'react-bootstrap';
import { BsCircleFill } from 'react-icons/bs';
import { FaEdit, FaFileDownload, FaRegEye } from 'react-icons/fa';
import { ModalItemsOrdersIntentions } from './modal/modal-items-orders-intentions';
import { OrdersIntentionsApprovalType } from '../../../../@types/enums/orders-intentions-approval-type-enum';
import { useOrderIntentionsLists } from 'data/context/analysis/orders-intetions-lists-context';
import ReactTooltip from 'react-tooltip';
import { TableHeaderStyled } from 'pages/style/table/table-header';

interface PropsOrdersIntentionsAccordion {
  title: string;
  emptyLabel: string;
  isOrder: boolean;
  ordersIntentionsDataList: OrdersIntentionsData[];
  viewActionFunction: (idPedidoIntencao: number, idSolicitante: number) => void;
  downloadOrderActionFunction: (orderNumber: number) => void;
}

const toBoolean = (value: any) => value === true || value === 'true' || value === 1 || value === '1';

export const OrdersIntentionsAccordion: React.FC<PropsOrdersIntentionsAccordion> = ({
  title,
  emptyLabel,
  isOrder,
  ordersIntentionsDataList,
  viewActionFunction,
  downloadOrderActionFunction,
}) => {
  let idLabel = isOrder ? 'Pedido ' : 'Intenção ';
  const [isEdit, setIsedit] = useState<boolean>(false);
  const [hasApproval, setHasApproval] = useState<boolean>(false);
  const [modalTitle, setModalTitle] = useState<string>('');
  const [modalDataType, setModalDataType] = useState<OrdersIntentionsApprovalType>(OrdersIntentionsApprovalType.ANALITICO);
  const [modalCampaignFull, setModalCampaignFull] = useState<boolean>(false);
  const [showModalItemsOI, updateShowModalItemsOI] = useState(false);
  const closeItemsOI = () => updateShowModalItemsOI(false);
  const showItemsOI = () => updateShowModalItemsOI(true);

  const { setObservacao, isGestorOrAdmin, setItems } = useOrderIntentionsLists();

  useMemo(() => {
    if (ordersIntentionsDataList !== null && ordersIntentionsDataList !== undefined && ordersIntentionsDataList.length > 0) {
      let flag = ordersIntentionsDataList.find((data) => data.statusAprovacao === 'Aguardando_Aprovacao');
      if (flag !== undefined) {
        setHasApproval(true);
      } else {
        setHasApproval(false);
      }
    }
    console.log('isGestorOrAdmin: ' + isGestorOrAdmin);
  }, [ordersIntentionsDataList]);

  function selectModalDataType(data: OrdersIntentionsData) {
    switch (data.origem) {
      case 'Analitico': {
        setModalDataType(OrdersIntentionsApprovalType.ANALITICO);
        break;
      }
      case 'Sintetico': {
        setModalDataType(OrdersIntentionsApprovalType.SINTETICO);
        break;
      }
      default: {
        setModalDataType(OrdersIntentionsApprovalType.CAMPANHA);
        break;
      }
    }
  }

  function colorStatus(status: string): React.CSSProperties {
    let colorStyle: React.CSSProperties;
    switch (status) {
      case 'Aprovado':
        colorStyle = { background: '#28A745', color: 'white', textAlign: 'center' };
        break;
      case 'Reprovado':
        colorStyle = { background: '#DC3444', color: 'white', textAlign: 'center' };
        break;
      default:
        colorStyle = { background: '#d8d8d8', color: 'black', textAlign: 'center' };
        break;
    }
    return colorStyle;
  }

  return (
    <>
      <Accordion defaultActiveKey="null">
        <Accordion.Item eventKey="0">
          <Accordion.Header>
            <div style={{ width: '100%', textAlign: 'center' }}>
              {title} {hasApproval ? <BsCircleFill size={10} style={{ color: '#CA2033' }} /> : <></>}
            </div>
          </Accordion.Header>
          <Accordion.Body style={{ maxHeight: '55vh', overflowY: 'auto' }}>
            {ordersIntentionsDataList && ordersIntentionsDataList.length > 0 ? (
              <TableHeaderStyled>
                <Table striped bordered hover responsive>
                  <thead>
                    <tr>
                      <th>{idLabel}</th>
                      {isOrder && <th>Nome pedido</th>}
                      <th>Data</th>
                      <th>Valor</th>
                      <th>Solicitante</th>
                      <th>Status</th>
                      <th>Observação</th>
                      <th style={{ textAlign: 'center' }}>Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {ordersIntentionsDataList.map((ordersIntentionsData) => (
                      <tr key={ordersIntentionsData.idPedidoIntencao}>
                        <td style={{ width: '8vw' }}>{isOrder ? ordersIntentionsData.numeroPedido : ordersIntentionsData.idPedidoIntencao}</td>
                        {isOrder && <td style={{ width: '8vw' }}>{ordersIntentionsData.nomePedido}</td>}
                        <td style={{ width: '8vw' }}>{ParseDateToBrWithHours(ordersIntentionsData.dataPedidoIntencao.toString()).replace(',', ' ')}</td>
                        <td style={{ width: '8vw' }}>
                          {Intl.NumberFormat('pt-BR', {
                            style: 'currency',
                            currency: 'BRL',
                          }).format(ordersIntentionsData.valorPedidoIntencao)}
                        </td>
                        <td style={{ width: '21vw' }}>{ordersIntentionsData.nomeSolicitante}</td>
                        <td style={{ width: '8vw', alignContent: 'center', justifyContent: 'center' }}>
                          <div style={colorStatus(ordersIntentionsData.statusAprovacao)}>
                            {ordersIntentionsData.statusAprovacao?.replace('_', ' ').replace('Aprovacao', 'Aprovação') || ''}
                          </div>
                        </td>
                        <td style={{ whiteSpace: 'normal', maxWidth: '14vw' }}>
                          <div className="obs-content" data-tip data-for={'tooltip_obs' + ordersIntentionsData.idPedidoIntencao}>
                            {ordersIntentionsData.observacao}
                          </div>
                          <ReactTooltip
                            id={'tooltip_obs' + ordersIntentionsData.idPedidoIntencao}
                            place="top"
                            backgroundColor={'#d8d8d8'}
                            textColor="black"
                            border
                          >
                            <span>{ordersIntentionsData.observacao}</span>
                          </ReactTooltip>
                        </td>
                        <td style={{ textAlign: 'right', width: '10vw' }}>
                          {(ordersIntentionsData.statusAprovacao === 'Aprovado') && (
                            <Button className="me-1" variant="success" size="sm" onClick={() => {
                              const id = isOrder ? ordersIntentionsData.numeroPedido : ordersIntentionsData.idPedidoIntencao;
                              downloadOrderActionFunction(id)
                            }}>
                              <FaFileDownload />
                            </Button>
                          )}
                          <Button
                            variant="primary"
                            size="sm"
                            onClick={() => {
                              const id = isOrder ? ordersIntentionsData.numeroPedido : ordersIntentionsData.idPedidoIntencao;
                              console.log("ordersIntentionsData: ", ordersIntentionsData);
                              const idSolicitante = ordersIntentionsData.idSolicitante;
                              setIsedit(ordersIntentionsData.statusAprovacao === 'Aguardando_Aprovacao' && isGestorOrAdmin);
                              setItems([]);
                              viewActionFunction(id, idSolicitante);
                              setModalTitle(isOrder ? 'Pedido: ' + id : 'Intenção: ' + id);
                              selectModalDataType(ordersIntentionsData);
                              setModalCampaignFull(toBoolean(ordersIntentionsData.campanhaFull));
                              setObservacao(ordersIntentionsData.observacao);
                              showItemsOI();
                            }}
                          >
                            {ordersIntentionsData.statusAprovacao === 'Aguardando_Aprovacao' && isGestorOrAdmin ? (
                              <>
                                Editar <FaEdit />
                              </>
                            ) : (
                              <>
                                Visualizar <FaRegEye />
                              </>
                            )}
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </TableHeaderStyled>
            ) : (
              <Row className="text-center" style={{ display: 'block' }}>
                {emptyLabel}
              </Row>
            )}
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>

      <ModalItemsOrdersIntentions
        showModalItemsOI={showModalItemsOI}
        closeModalItemsOI={closeItemsOI}
        title={modalTitle}
        type={modalDataType}
        isEdit={isEdit}
        campaignFull={modalCampaignFull}
      />
    </>
  );
};
